import { render, staticRenderFns } from "./action-button.vue?vue&type=template&id=473346e1&lang=pug"
import script from "./action-button.vue?vue&type=script&lang=ts"
export * from "./action-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports